<template>
  <div class="entity-nav-container">
    <div class="dropdown">
      <button
        class="btn dropdown-toggle d-flex align-items-center gap-3 custom-select-btn"
        type="button"
        @click="toggleDropdown"
      >
        <!-- <div class="selected-logo-wrapper">
          <img
            :src="selectedEntity.legal_company_logo"
            :alt="selectedEntity.legal_company_name"
            class="img-fluid"
          />
        </div>
        <span class="fw-medium">{{ selectedEntity.legal_company_name }}</span> -->
        <span class="fw-medium">Switch Company</span>
        <i
          class="fa ms-auto small transition-icon"
          :class="isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"
        ></i>
      </button>

      <ul v-if="isOpen" class="custom-dropdown-menu shadow-sm border rounded">
        <li
          v-for="entity in entityDetails"
          :key="entity.id"
          class="dropdown-arrow d-flex align-items-center gap-2 py-4 border-bottom h-25 bg-white"
          @click="selectEntity(entity)"
        >
          <div class="d-flex align-items-center gap-3 check">
            <div class="radio-wrapper">
              <input
                type="radio"
                name="entity"
                :value="entity.legal_company_code"
                v-model="selectedEntityCode"
              />
              <span class="custom-radio"></span>
            </div>
            <div>
              <img
                :src="entity.legal_company_logo"
                width="40"
                :alt="entity.legal_company_name"
              />
              <span class="medium">{{ entity.legal_company_name }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "EntityNav",
  props: { msg: String },

  data() {
    return {
      isOpen: false,
      entityDetails: [],
      selectedEntity: {},
      selectedEntityCode: "",
      account: {},
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.entityDetails = this.$store.getters.entityDetails;
        const storeEntity = this.$store.getters.entity;
        const matched = this.entityDetails.find(
          (e) => e.legal_company_code === storeEntity,
        );
        this.selectedEntity = matched || this.entityDetails[0] || {};
        this.selectedEntityCode = this.selectedEntity.legal_company_code || "";
      },
    },
  },

  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    async selectEntity(entity) {
      this.selectedEntity = entity;
      this.selectedEntityCode = entity.legal_company_code;
      this.isOpen = false;
      this.$store.commit("set_entity", this.selectedEntity.legal_company_code);

      const success = await this.handleAccountLegalEntity();

      if (success) {
        this.$router.push("/home");
      }
    },

    async handleAccountLegalEntity() {
      this.$swal.fire({
        title: "Switching Company...",
        html: this.$preloader,
        showConfirmButton: false,
        showCancelButton: false,
        allowOutsideClick: false,
      });

      try {
        this.account.primary_legal_entity = this.$store.getters.entity;
        this.account.vendor_no = this.$store.getters.vendor_no;

        let data = this.loadNew(this.account);
        const res = await axios({
          method: "get",
          url: this.$hostname + "/get-accounts-by-legal-entity",
          headers: {
            "Content-Type": "application/json",
            "X-Request-IV": data.iv,
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
          params: {
            token: data.cipher,
          },
        });

        this.$swal.close();

        if (!res.data.data || res.data.data.length === 0) {
          const legalEntity = res.data.primary_legal_entity;
          const errorMessage =
            legalEntity === "HFMN"
              ? "Honeywell account isn't registered to this user yet"
              : "FMN account isn't registered for this user yet";

          this.$swal.fire("Alert", errorMessage, "error");
          return false;
        }

        this.$store.commit("set_subaccounts", res.data.data);
        return true;
      } catch (error) {
        console.error("Error during login:", error);
        this.$swal.close();
        if (error.response && error.response.status === 401) {
          this.is401(error.response.status);
        }
        return false;
      }
    },
  },
};
</script>
<style>
.check {
  display: flex;
  align-items: center;
}
.check .medium {
  padding-left: 2px;
}
</style>
